import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { useLanguage } from "../../Context/LanguageContext";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

const drawerWidth = 220;
const collapsedWidth = 64;

const AdminLayout = () => {
  const { lang } = useLanguage();
  const actualLang = lang === "rn" ? "en" : lang || "ar";
  const isRTL = actualLang.startsWith("ar");
  const anchor = isRTL ? "right" : "left";

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const sidebarCurrentWidth = sidebarOpen ? drawerWidth : collapsedWidth;
 useEffect(() => {
		document.title = 'DIDA — DASHBOARD';
	}, []);
  return (
    <>
      <CssBaseline />

      <AdminSidebar
        anchor={anchor}
        open={sidebarOpen}
        onToggle={() => setSidebarOpen((prev) => !prev)}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
      />

      <AdminHeader
        sidebarOpen={sidebarOpen}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
        anchor={anchor}
        onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
      />

      <Box
        component="main"
        sx={{
          transition: "all 0.2s ease",
          width: `calc(100% - ${sidebarCurrentWidth}px)`,
          ...(anchor === "left"
            ? { ml: `${sidebarCurrentWidth}px` }
            : { mr: `${sidebarCurrentWidth}px` }),
          px: 2,
          pt: 0, // ✅ خليها 0 وسيب الـ spacer يعمل التعويض
        }}
      >
        {/* ✅ أفضل Spacer للهيدر */}
        <Box sx={(theme) => theme.mixins.toolbar} />

        <Box sx={{ mt: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default AdminLayout;
